<div class="checklist-item" [class.checked]="checklistItem.checked">
	<div class="checkmark" (click)="markAsDone()">
		<mat-icon class="check-icon white-icon" svgIcon="checkmark"></mat-icon>
	</div>
	<p class="check-item-text">{{ checklistItem.text }}</p>
</div>
